// Sub-header menu bar: glides up behind the header on scroll down, glides back on scroll up.
// Uses transform only (GPU-composited) so the motion stays smooth on phones.
const bar = document.querySelector('[data-subheader]');
const inner = bar && bar.querySelector('[data-subheader-inner]');
const spacer = document.querySelector('[data-subheader-spacer]');

if (bar && inner) {
  // Reserve the bar's real height at page top so content never hides under it.
  const syncHeight = () => {
    if (spacer) spacer.style.height = `${inner.offsetHeight}px`;
  };
  syncHeight();
  if ('ResizeObserver' in window) new ResizeObserver(syncHeight).observe(inner);

  // Clip only while hidden or moving, so desktop dropdowns are never cut off when the bar is open.
  inner.addEventListener('transitionend', (event) => {
    if (event.propertyName === 'transform' && !bar.hasAttribute('data-hidden')) {
      bar.removeAttribute('data-clip');
    }
  });

  const hide = () => {
    if (bar.hasAttribute('data-hidden')) return;
    bar.setAttribute('data-clip', '');
    bar.setAttribute('data-hidden', '');
    bar.inert = true; // hidden links can't be tabbed to or tapped
  };
  let unclipTimer = 0;
  const show = () => {
    if (!bar.hasAttribute('data-hidden')) return;
    bar.setAttribute('data-clip', '');
    bar.removeAttribute('data-hidden');
    bar.inert = false;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) bar.removeAttribute('data-clip');
    // Backup: an interrupted slide can skip transitionend, leaving the bar clipped (its bottom shadow hidden).
    clearTimeout(unclipTimer);
    unclipTimer = setTimeout(() => {
      if (!bar.hasAttribute('data-hidden')) bar.removeAttribute('data-clip');
    }, 600);
  };

  // Start unclipped (visible).
  requestAnimationFrame(() => bar.removeAttribute('data-clip'));

  let lastY = window.scrollY;
  let ticking = false;
  const THRESHOLD = 6; // ignore tiny jitter
  const TOP_ZONE = 80; // always visible near the top

  const update = () => {
    // Clamp to the real scroll range: phones bounce past the bottom on a fast scroll, and that bounce
    // must not count as "scrolling up" (it made the menu bar flicker in and out over the footer).
    const maxY = Math.max(document.documentElement.scrollHeight - window.innerHeight, 0);
    const y = Math.min(Math.max(window.scrollY, 0), maxY);
    // Also ignore the footer scroll-stop's snap-back (layout sets data-scroll-hold while it holds).
    if (document.documentElement.hasAttribute('data-scroll-hold') || (y >= maxY - 2 && lastY >= maxY - 60)) {
      lastY = y;
      ticking = false;
      return;
    }
    const delta = y - lastY;
    const busy = bar.querySelector('[aria-expanded="true"]');

    if (y <= TOP_ZONE || busy) show();
    else if (delta > THRESHOLD) hide();
    else if (delta < -THRESHOLD) show();

    if (Math.abs(delta) > THRESHOLD || y <= TOP_ZONE) lastY = y;
    ticking = false;
  };

  window.addEventListener(
    'scroll',
    () => {
      if (!ticking) {
        ticking = true;
        requestAnimationFrame(update);
      }
    },
    { passive: true }
  );
}
